import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconAlertTriangle = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z' />
      <path d='M12 9v4M12 17h.01' />
    </g>
  </SDIcon>
)

export default IconAlertTriangle
